import { Component, effect, input } from '@angular/core';
import { COUNTRY_CODE } from '@core/enums';

@Component({
  selector: 'lib-display-address-phone',
  standalone: true,
  templateUrl: './display-address-phone.component.html',
  styleUrls: ['./display-address-phone.component.scss'],
})
export class DisplayAddressPhoneLibComponent {
  address = input.required<string>();
  city = input.required<string>();
  state = input.required<string>();
  country = input.required<string>();
  postalCode = input.required<string>();
  phone = input<string>();

  showPostalCode = false;
  fullAddress?: string;

  constructor() {
    effect(() => {
      this.showPostalCode = this.#showPostalCode();
      this.fullAddress = this.#getAddressString();
    });
  }

  readonly #showPostalCode = (): boolean => this.country() === COUNTRY_CODE.BRAZIL;

  readonly #getAddressString = (): string => {
    const addressParts = [];

    if (this.city) {
      addressParts.push(this.city());
    }

    if (this.state) {
      addressParts.push(this.state());
    }

    if (this.showPostalCode && this.postalCode()) {
      addressParts.push(this.postalCode());
    }

    return addressParts.join(', ');
  }


}
